export default __webpack_public_path__ + "static/media/ipl_2.31feb179.png";